module.exports = __webpack_public_path__ + "img/ai.5c4e2a0b.png";